import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { CheckboxFilterGroup, FilterPanel } from '../../../generic/Filter';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import type { ProjectsFilter, ProjectType as ProjType } from '../../../../../shared/projectsV2';
import { FilterKeys } from '../../../../../shared/projectsV2';
import type { FilterOption } from '../../../generic/Filter/CheckboxFilterGroup';

const FILTER_OPTIONS: FilterOption[] = [
  { key: 'provided', label: 'CLI upload' },
  { key: 'container', label: 'Container' },
  { key: 'archive', label: 'Archive upload' },
  { key: 'autobuild', label: 'Quick import' },
  { key: 'sbom', label: 'SBOM import' },
];

const ProjectType: VoidFunctionComponent = () => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter) as ProjectsFilter;
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  const onSelect = (key: string, selected: boolean) => {
    const type = key as ProjType;

    // add if selected and not present
    if (selected && !filter.type?.includes(type)) {
      const current = filter.type ?? [];
      const added = [...current, type];
      setFilter({ ...filter, [FilterKeys.Type]: added });
    }

    // remove if unselected and present
    if (!selected && filter.type?.includes(type)) {
      const current = filter.type ?? [];
      const removed = current.filter(t => t !== type);
      setFilter({ ...filter, [FilterKeys.Type]: removed });
    }
  };

  return (
    <FilterPanel>
      <CheckboxFilterGroup
        title="Project attributes"
        options={FILTER_OPTIONS}
        selectedOptions={filter.type}
        onSelect={onSelect}
      />
    </FilterPanel>
  );
};

export default ProjectType;
